const useDetectBackButton = (callback: () => void, execute?: boolean) => {
    if (execute) {
        window.onpopstate = (e) => {
            e.preventDefault()
            callback()
            window.onpopstate = null
        }
        window.onbeforeunload = (e) => {
            e.preventDefault()
            callback()
            window.onbeforeunload = null
        }
    }
}

export { useDetectBackButton }
